// @ts-nocheck
import React from 'react'
import cx from 'classnames'

import { Box } from 'components/layout/Box/Box'
import { Header } from './common/Header/Header'
import { Panel } from './common/Panel/Panel'

import { AccordionContext } from './context'

import styles from './Accordion.module.scss'

export const Accordion = ({
  children,
  className = '',
  isDisabled = false,
  isInitiallyOpen = false,
}) => {
  const [isOpen, setIsOpen] = React.useState(isInitiallyOpen)

  const handleToggle = React.useCallback(() => {
    setIsOpen(prevState => !prevState)
  }, [setIsOpen])

  const context = React.useMemo(
    () => ({
      handleToggle,
      isDisabled,
      isOpen,
    }),
    [handleToggle, isDisabled, isOpen],
  )

  React.useEffect(() => {
    setIsOpen(isInitiallyOpen)
  }, [isInitiallyOpen])

  return (
    <Box className={cx(styles.accordion, className)} direction="column">
      <AccordionContext.Provider value={context}>
        {children}
      </AccordionContext.Provider>
    </Box>
  )
}

Accordion.Header = Header
Accordion.Panel = Panel
